// Runtime config: read window.__APP_CONFIG__ (written by docker-entrypoint.sh
// via envsubst at container start). Fall back to process.env for `npm start`
// (dev mode reads .env.development), and finally to empty/sane defaults.
const runtime = typeof window !== 'undefined' ? window.__APP_CONFIG__ || {} : {};

const isPlaceholder = (v) => !v || v.startsWith('${');

export const API_URL = isPlaceholder(runtime.apiUrl)
  ? process.env.REACT_APP_API_URL || ''
  : runtime.apiUrl;

export const BACKEND_URL = isPlaceholder(runtime.backendUrl)
  ? process.env.REACT_APP_BACKEND_URL || API_URL
  : runtime.backendUrl;
